import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { SwUpdate, VersionEvent } from '@angular/service-worker';
import { Router, NavigationEnd } from '@angular/router';
import { TokenService } from './auth/auth/token.service';
import { StorageService } from './servicios/storage/storage.service';
import { OperacionesService } from './servicios/tienda/operaciones.service';
import { AdminService } from './servicios/admin/admin.service';
import { Subscription, filter } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'universo-tunning-2.0';

  // Update policy
  private readonly UPDATE_MODE: 'AUTO' | 'BLOCKING' = 'BLOCKING';
  private readonly AUTO_UPDATE_COUNTDOWN_SECONDS = 10;
  private updateCountdownTimer: any = null;
  private updateApplying = false;

  public footer = true;

  private subscriptions: Subscription = new Subscription();
  Estado = 'OnLine';

  constructor(
    private storageService: StorageService,
    private tokenService: TokenService,
    private otroService: OperacionesService,
    private adminService: AdminService,
    private sw: SwUpdate,
    private zone: NgZone,
    private router: Router
  ) {
    this.consultarEstadoTienda();
    console.log(sw.isEnabled)

    if (this.sw.isEnabled) {
      // Check on boot
      this.sw.checkForUpdate().catch(() => {});

      // Check again when the tab becomes visible
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          this.sw.checkForUpdate().catch(() => {});
        }
      });

      // Show banner when a new version is ready
      this.sw.versionUpdates.subscribe((event: VersionEvent) => {
        if (event.type === 'VERSION_READY') {
          console.log(`Current version: ${event.currentVersion.hash}`);
          console.log(`New version: ${event.latestVersion.hash}`);

          if (this.UPDATE_MODE === 'AUTO') {
            this.zone.run(() => this.applyUpdateAndReload());
          } else {
            this.zone.runOutsideAngular(() => this.renderUpdateBanner(true));
          }
        }
      });
    }
  }

  ngOnInit() {
    this.nuevaVisita();
    this.verificarSesion();

    this.subscriptions.add(
      this.router.events
        .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.footer = !event.urlAfterRedirects.includes('carrito');
          this.verificarSesion();
        })
    );

    this.footer = !window.location.href.includes('carrito');
  }

  nuevaVisita() {
    this.otroService.nuevaVisita().subscribe();
  }

  consultarEstadoTienda() {
    this.subscriptions.add(
      this.adminService.consultarEstadoTienda().subscribe((resp) => {
        this.Estado = resp.data;
      })
    );
  }

  verificarSesion() {
    if (this.tokenService.getToken() && !this.tokenService.notExpired()) {
      this.tokenService.logOut();
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  private renderUpdateBanner(blocking: boolean = false): void {
    const existing = document.getElementById('app-update-banner');
    if (existing) existing.remove();
    const existingOverlay = document.getElementById('app-update-overlay');
    if (existingOverlay) existingOverlay.remove();

    if (blocking) {
      const overlay = document.createElement('div');
      overlay.id = 'app-update-overlay';
      overlay.setAttribute('style', `
        position: fixed; inset: 0;
        background: rgba(0,0,0,.55);
        z-index: 2147483646;
        backdrop-filter: blur(2px);
      `);
      document.body.appendChild(overlay);
    }

    const banner = document.createElement('div');
    banner.id = 'app-update-banner';
    banner.setAttribute('style', `
      position: fixed;
      left: 50%; bottom: 24px;
      transform: translateX(-50%);
      width: 70%; max-width: 640px;
      padding: 14px 22px;
      background: rgba(17, 24, 39, 0.95);
      color: #fff;
      border-radius: 90px;
      display: flex; align-items: center; justify-content: space-between;
      gap: 12px; z-index: 2147483647;
      box-shadow: 0 4px 20px rgba(0,0,0,.4);
      font-family: system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
      backdrop-filter: blur(10px);
    `);

    const text = document.createElement('div');
    text.id = 'app-update-text';
    text.textContent = blocking
      ? 'Hay una nueva versión del sitio. Se actualizará en breve.'
      : 'Hay una nueva versión del sitio.';

    const actions = document.createElement('div');
    actions.setAttribute('style', 'display:flex; gap:8px; align-items:center');

    if (!blocking) {
      const later = document.createElement('button');
      later.textContent = 'Luego';
      later.setAttribute('style', 'background:#374151;color:#fff;border:none;padding:8px 12px;border-radius:6px;cursor:pointer');
      later.addEventListener('click', () => banner.remove());
      actions.appendChild(later);
    }

    if (blocking) {
      const countdown = document.createElement('span');
      countdown.id = 'app-update-countdown';
      countdown.setAttribute('style', 'font-size:12px; opacity:.9');
      actions.appendChild(countdown);
      this.startCountdown();
    }

    const update = document.createElement('button');
    update.id = 'app-update-now';
    update.textContent = 'Actualizar';
    update.setAttribute('style', 'background:#ef4444;color:#fff;border:none;padding:8px 12px;border-radius:6px;cursor:pointer;font-weight:600');
    update.addEventListener('click', () => this.applyUpdateAndReload());

    actions.appendChild(update);
    banner.appendChild(text);
    banner.appendChild(actions);
    document.body.appendChild(banner);
  }

  private startCountdown(): void {
    let remaining = this.AUTO_UPDATE_COUNTDOWN_SECONDS;
    const label = document.getElementById('app-update-countdown');
    if (label) label.textContent = `Actualizando en ${remaining}s...`;

    this.updateCountdownTimer = setInterval(() => {
      remaining--;
      const el = document.getElementById('app-update-countdown');
      if (el) el.textContent = `Actualizando en ${remaining}s...`;
      if (remaining <= 0) {
        clearInterval(this.updateCountdownTimer);
        this.applyUpdateAndReload();
      }
    }, 1000);
  }

  private async applyUpdateAndReload(): Promise<void> {
    if (this.updateApplying) return;
    this.updateApplying = true;
    try { await this.sw.activateUpdate(); } catch {}
    location.reload();
  }

  actualizar(){

    location.reload();
  }
}
